export const tableHeight = (customOffest = 48 - 64) => ({
  data() {
    return {
      tableHeight: 0,
    }
  },

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  methods: {
    onResize() {
      this.tableHeight = `${window.innerHeight - customOffest}px`
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
})
